import _ from 'lodash'
import {
  ADDRESS_PROPS,
  ADDRESS_OPTIONAL_REQUIRED_PROPS,
} from '../constants/address'

/*
 * Check if any of the address fields are set
 * @params allValues Object the redux form values sent to API
 */
export const isAnyAddressFieldSet = (
  address,
  additionalFields = ADDRESS_PROPS
) => {
  const { street_name: streetName, street_number: streetNumber } = address
  // Create address object that holds all parts of an address
  const addressFields = Object.assign(_.pick(address, additionalFields), {
    streetName,
    streetNumber,
  })
  // This will be true if any address part is set
  return _.some(addressFields, val => !_.isEmpty(val))
}

/*
 * Check if any of the required optional fields is empty
 * @params allValues Object the optional required values to check
 */
export const isAnyOptReqAddressFieldEmpty = allValues => {
  if (!allValues.venueAddressSuggestion) allValues.venueAddressSuggestion = {}
  const {
    venueAddressSuggestion: { street_name: streetName },
  } = allValues
  // create object of optional required address fields
  const optionalRequiredAddressProps = Object.assign(
    _.pick(allValues, ADDRESS_OPTIONAL_REQUIRED_PROPS),
    { streetName }
  )
  // check if any of those values are empty
  return _.some(optionalRequiredAddressProps, val => _.isEmpty(val))
}

/*
 * @params address Object address object of all fields describing an addressSuggestionField
 * This formatter expects the fields in snake case
 */
export const formatAddress = address => {
  if (_.isEmpty(address)) return {}
  const venueAddress = {}
  venueAddress.address = _.trim(
    `${address.street_number || ''} ${address.street_name || ''}`
  )
  venueAddress.municipality = address.municipality || ''
  venueAddress.country_primary_subdivision =
    address.country_primary_subdivision || ''
  venueAddress.postal_code = address.postal_code || ''
  venueAddress.country_secondary_subdivision =
    address.country_secondary_subdivision || ''
  return venueAddress
}
